import {
  AccountBalance as AccountBalanceIcon,
  SvgIconComponent,
  Quiz as QuizIcon,
  Group as GroupIcon,
  History as HistoryIcon,
  Home as HomeIcon,
  QuestionAnswer as QuestionAnswerIcon,
  Payment as PaymentIcon,
  School as SchoolIcon,
  CalendarMonth as CalendarMonthIcon,
  EventRepeat as EventRepeatIcon,
} from '@mui/icons-material';

export const NAVIGATION_OPTION_KEYS = {
  HOME: 'HOME',
  QUIZ_HISTORY: 'QUIZ_HISTORY',
  STUDENTS: 'STUDENTS',
  SUBSCRIPTIONS: 'SUBSCRIPTIONS',
  COURSES: 'COURSES',
  SCHEDULE: 'SCHEDULE',
  RESCHEDULE_REQUESTS: 'RESCHEDULE_REQUESTS',
  QUESTIONS: 'QUESTIONS',
  QUESTION_BANK: 'QUESTION_BANK',
  QUIZ_BANK: 'QUIZ_BANK',
} as const;

export type TNavigationOptionKeys = typeof NAVIGATION_OPTION_KEYS[keyof typeof NAVIGATION_OPTION_KEYS];

export interface INavigationRoutesV2 {
  key: TNavigationOptionKeys;
  name: string;
  pathname: string;
  icon: SvgIconComponent;
  matches: string[];
}

export interface INavigationRoutes {
  key: string;
  name: string;
  pathname: string;
  icon: SvgIconComponent;
  matches: string[];
}

export const APP_NAVIGATION_OPTIONS: INavigationRoutesV2[] = [
  {
    key: NAVIGATION_OPTION_KEYS.HOME,
    name: 'Home',
    pathname: `${process.env.PUBLIC_URL}/`,
    icon: HomeIcon,
    matches: [],
  },
  {
    key: NAVIGATION_OPTION_KEYS.COURSES,
    name: 'Courses',
    pathname: `${process.env.PUBLIC_URL}/portal/courses`,
    icon: SchoolIcon,
    matches: [],
  },
  {
    key: NAVIGATION_OPTION_KEYS.SCHEDULE,
    name: 'Schedule',
    pathname: `${process.env.PUBLIC_URL}/portal/schedule`,
    icon: CalendarMonthIcon,
    matches: [],
  },
  {
    key: NAVIGATION_OPTION_KEYS.RESCHEDULE_REQUESTS,
    name: 'Reschedule Requests',
    pathname: `${process.env.PUBLIC_URL}/portal/reschedule-requests`,
    icon: EventRepeatIcon,
    matches: [],
  },
  {
    key: NAVIGATION_OPTION_KEYS.QUIZ_HISTORY,
    name: 'Quiz History',
    pathname: `${process.env.PUBLIC_URL}/dashboard/quiz-history`,
    icon: HistoryIcon,
    matches: [
      // `${process.env.PUBLIC_URL}/dashboard/quiz-history/submissions/:quizId`,
      // `${process.env.PUBLIC_URL}/dashboard/quiz-history/questions/:submissionId`,
      // `${process.env.PUBLIC_URL}/dashboard/quiz-history/submissions/:quizId/:pattern`,
      // `${process.env.PUBLIC_URL}/dashboard/quiz-history/questions/:submissionId/:pattern`,
    ],
  },
  {
    key: NAVIGATION_OPTION_KEYS.STUDENTS,
    name: 'Students',
    pathname: `${process.env.PUBLIC_URL}/dashboard/students`,
    icon: GroupIcon,
    matches: [
      // `${process.env.PUBLIC_URL}/dashboard/students/submissions/:userId`,
      // `${process.env.PUBLIC_URL}/dashboard/students/viewQuestions/:userId/:submissionId`,
    ],
  },
  {
    key: NAVIGATION_OPTION_KEYS.SUBSCRIPTIONS,
    name: 'Manage Subscription',
    pathname: `${process.env.PUBLIC_URL}/subscriptions`,
    icon: PaymentIcon,
    matches: [],
  },
  {
    key: NAVIGATION_OPTION_KEYS.QUESTIONS,
    name: 'Questions',
    pathname: `${process.env.PUBLIC_URL}/dashboard/questions`,
    icon: QuestionAnswerIcon,
    matches: [],
  },
  {
    key: NAVIGATION_OPTION_KEYS.QUESTION_BANK,
    name: 'Question Bank',
    pathname: `${process.env.PUBLIC_URL}/dashboard/question-bank`,
    icon: AccountBalanceIcon,
    matches: [
      // `${process.env.PUBLIC_URL}/dashboard/question-bank/sub-topics/:subjectCode`,
      // `${process.env.PUBLIC_URL}/dashboard/question-bank/questions/:subTopicId`,
    ],
  },
  {
    key: NAVIGATION_OPTION_KEYS.QUIZ_BANK,
    name: 'Quiz',
    pathname: `${process.env.PUBLIC_URL}/dashboard/quiz-bank`,
    icon: QuizIcon,
    matches: [
      // `${process.env.PUBLIC_URL}/dashboard/quiz-bank/quizzes/:subjectCode`,
      // `${process.env.PUBLIC_URL}/dashboard/quiz-bank/questions/:quizId`,
    ],
  },
];

export const ADMIN_NAVIGATION_ROUTES: INavigationRoutes[] = [
  // {
  //   key: 'dashboard',
  //   name: 'Dashboard',
  //   pathname: `${process.env.PUBLIC_URL}/dashboard`,
  //   icon: DashboardIcon,
  //   matches: [],
  // },
  {
    key: 'questions',
    name: 'Questions',
    pathname: `${process.env.PUBLIC_URL}/dashboard/questions`,
    icon: QuestionAnswerIcon,
    matches: [],
  },
  {
    key: 'question-bank',
    name: 'Question Bank',
    pathname: `${process.env.PUBLIC_URL}/dashboard/question-bank`,
    icon: AccountBalanceIcon,
    matches: [
      `${process.env.PUBLIC_URL}/dashboard/question-bank/sub-topics/:subjectCode`,
      `${process.env.PUBLIC_URL}/dashboard/question-bank/questions/:subTopicId`,
    ],
  },
  {
    key: 'quiz-bank',
    name: 'Quiz',
    pathname: `${process.env.PUBLIC_URL}/dashboard/quiz-bank`,
    icon: QuizIcon,
    matches: [
      `${process.env.PUBLIC_URL}/dashboard/quiz-bank/quizzes/:subjectCode`,
      `${process.env.PUBLIC_URL}/dashboard/quiz-bank/questions/:quizId`,
    ],
  },
  {
    key: 'students',
    name: 'Students',
    pathname: `${process.env.PUBLIC_URL}/dashboard/students`,
    icon: GroupIcon,
    matches: [
      `${process.env.PUBLIC_URL}/dashboard/students/submissions/:userId`,
      `${process.env.PUBLIC_URL}/dashboard/students/viewQuestions/:userId/:submissionId`,
    ],
  },
  {
    key: 'courses',
    name: 'Courses',
    pathname: `${process.env.PUBLIC_URL}/portal/courses`,
    icon: SchoolIcon,
    matches: [],
  },
];

export const userNavigationRoutes: INavigationRoutes[] = [
  {
    key: 'home',
    name: 'Home',
    pathname: `${process.env.PUBLIC_URL}/`,
    icon: HomeIcon,
    matches: [],
  },
  // {
  //   key: 'dashboard',
  //   name: 'Dashboard',
  //   pathname: `${process.env.PUBLIC_URL}/dashboard`,
  //   icon: DashboardIcon,
  //   matches: [],
  // },
  // {
  //   key: 'my-quizzes',
  //   name: 'My Quiz',
  //   pathname: '/dashboard/my-quizzes',
  //   icon: QuizIcon,
  //   matches: [
  //     '/dashboard/my-quizzes',
  //     '/dashboard/my-quizzes/subTopic/:pattern',
  //     '/dashboard/my-quizzes/resources/subTopic/:pattern',
  //     '/dashboard/my-quizzes/subtopic/:subtopicId/:submissionId/:pattern',
  //   ],
  // },
  {
    key: 'quiz-history',
    name: 'Quiz History',
    pathname: `${process.env.PUBLIC_URL}/dashboard/quiz-history`,
    icon: HistoryIcon,
    matches: [
      // `${process.env.PUBLIC_URL}/dashboard/quiz-history/submissions/:quizId`,
      // `${process.env.PUBLIC_URL}/dashboard/quiz-history/questions/:submissionId`,
      // `${process.env.PUBLIC_URL}/dashboard/quiz-history/submissions/:quizId/:pattern`,
      // `${process.env.PUBLIC_URL}/dashboard/quiz-history/questions/:submissionId/:pattern`,
    ],
  },
  {
    key: 'students',
    name: 'Students',
    pathname: `${process.env.PUBLIC_URL}/dashboard/students`,
    icon: GroupIcon,
    matches: [
      `${process.env.PUBLIC_URL}/dashboard/students/submissions/:userId`,
      `${process.env.PUBLIC_URL}/dashboard/students/viewQuestions/:userId/:submissionId`,
    ],
  },
  {
    key: 'subscriptions',
    name: 'Manage Subscription',
    pathname: `${process.env.PUBLIC_URL}/subscriptions`,
    icon: PaymentIcon,
    matches: [],
  },
  {
    key: 'courses',
    name: 'Courses',
    pathname: `${process.env.PUBLIC_URL}/portal/courses`,
    icon: SchoolIcon,
    matches: [],
  },
];

export const userNavigationBarAllowedRoutes = [
  `${process.env.PUBLIC_URL}/dashboard/my-quizzes/subtopic/:pattern`,
  `${process.env.PUBLIC_URL}/dashboard/my-quizzes/resources/subtopic/:pattern`,
  `${process.env.PUBLIC_URL}/dashboard/quiz-history/submissions/:quizId/:pattern`,
  `${process.env.PUBLIC_URL}/dashboard/my-quizzes/subtopic/:subtopicId/:submissionId/:pattern`,
  `${process.env.PUBLIC_URL}/dashboard/quiz-history/questions/:submissionId/:pattern`,
  `${process.env.PUBLIC_URL}/:curriculum/:subject/:subTopic`,
  `${process.env.PUBLIC_URL}/dashboard/my-quizzes/diagnostic/:subtopicId/:submissionId/:pattern`,
];
